import moment from 'moment'

class TimeAndDate {
  static formatWithoutSeconds(date) {
    return moment(date || undefined).format('DD/MM/YYYY HH:mm')
  }

  /**
   * Convert from milliseconds to the required unit
   * @param {object} data
   * @param {string} data.unit
   * @param {number} data.time
   *
   * @returns {{unit: string, time: number}}
   */
  static millisecondsToUnit(data) {
    const unit = data.unit || 'seconds'
    let time = data.time || 0

    if (!unit || !time || time < 0) return { unit, time: 0 }

    const duration = moment.duration(time, 'milliseconds')

    switch (unit) {
      case 'hours':
        time = duration.asHours().toString()
        break
      case 'days':
        time = duration.asDays().toString()
        break
      case 'minutes':
        time = duration.asMinutes().toString()
        break
      case 'seconds':
        time = duration.asSeconds().toString()
        break
      case 'months':
        time = duration.asMonths().toString()
        break
      default:
        time = duration.asSeconds().toString()
        break
    }

    return {
      unit, time
    }
  }

  /**
   * Convert to milliseconds
   * @param {object} data
   * @param {string} data.unit
   * @param {number} data.time
   *
   * @returns {{unit: string, time: number}}
   */
  static timeToMilliseconds(data) {
    const unit = data.unit || 'seconds'
    let time = data.time || 0

    if (!unit || !time || time < 0) return { unit, time: 0 }

    const duration = moment.duration(time, unit)

    return {
      unit,
      time: duration.asMilliseconds()
    }
  }

  /**
   * Transform date in utc
   * @param {string} date
   * @param {object} [options]
   * @param {boolean} [options.startOfDay] Change the time to be the beginning of the day
   * @param {boolean} [options.endOfDay] Change the time to be the end of the day
   *
   * @returns {string}
   */
  static dateToUTC(date, options = {}) {
    if (!date) return ''

    const { endOfDay, startOfDay } = options

    const d = moment(date)
    if (!d.isValid()) return ''

    if (startOfDay) return d.startOf('day').toISOString()
    if (endOfDay) return d.endOf('day').toISOString()

    return d.toISOString()
  }

  /**
   * Returns the range of dates at the start and end of the day
   * @param {string} dateStart
   * @param {string} dateEnd
   *
   * @returns [string, string]
   */
  static betweenEndStartDayUTC(dateStart, dateEnd) {
    return [
      TimeAndDate.dateToUTC(dateStart, { startOfDay: true }),
      TimeAndDate.dateToUTC(dateEnd, { endOfDay: true })
    ]
  }

  static timeSince = (date) => {
    const originDate = new Date(date)
    const currentDate = new Date()
    const msDifferences = currentDate.getTime() - originDate.getTime()
    const minDifferences = Math.round(msDifferences / (1000 * 60))
    const hoursDifferences = Math.round(msDifferences / (1000 * 60 * 60))
    const daysDifferences = Math.round(msDifferences / (1000 * 60 * 60 * 24))

    let timeElapsed = {}
    if (minDifferences < 60) {
      timeElapsed = { time: minDifferences, unit: 'min' }
    } else if (hoursDifferences < 24) {
      timeElapsed = { time: hoursDifferences, unit: hoursDifferences <= 1 ? 'dashboard_hour' : 'dashboard_hours' } 
    } else {
      timeElapsed = { time: daysDifferences, unit: daysDifferences <= 1 ? 'dashboard_day' : 'dashboard_days' }
    }
    return timeElapsed
  };
}

export default TimeAndDate